// "Did you know?" — the gestures nothing on screen advertises, offered one at a
// time in the command bar while Select is idle. A tip that fits what is on screen
// right now (a heater selected, an underlay present…) wins; otherwise they take
// turns. Pure and DOM-free (unit-tested); the texts are English (DICT keys).

export interface TipContext {
  heaterSelected: boolean;
  roomSelected: boolean;
  hasUnderlay: boolean;
  partsTabOpen: boolean;
  sheetOpen: boolean;
}

interface Tip { text: string; when?: (c: TipContext) => boolean }

export const TIPS: readonly Tip[] = [
  { text: 'Hover the gap edge of a selected heater to add a guard cover; hover the cover to clear it.', when: (c) => c.heaterSelected },
  { text: 'Drag the short line where two figures of a wall meet to move a door or pane edge.', when: (c) => c.roomSelected },
  { text: 'Right-click a pinned (padlocked) figure to release it.', when: (c) => c.roomSelected },
  { text: 'Drag rows in the Parts tab to change what is drawn on top.', when: (c) => c.partsTabOpen },
  { text: 'Drag a sheet’s thumbnail or tab to change the sheet order.', when: (c) => c.sheetOpen },
  { text: 'Double-click an imported plan or image to move, scale or rotate it.', when: (c) => c.hasUnderlay },
  { text: 'Right-click the Snap button to choose which snaps are on.' },
  { text: 'Tab (or Alt+click) picks the next object stacked under the cursor.' },
  { text: 'Space-drag pans the view, whatever tool is armed.' },
  { text: 'Hold Ctrl while dragging to leave a copy behind.' },
  { text: 'Type a command in the bar — or just words, to search for one.' },
];

/** The tip to show: every tip that fits the context takes its turn first (by
 *  `turn`); with none fitting, the general tips take turns. */
export function pickTip(c: TipContext, turn: number): string {
  const fitting = TIPS.filter((t) => t.when?.(c));
  const pool = fitting.length ? fitting : TIPS.filter((t) => !t.when);
  return pool[((turn % pool.length) + pool.length) % pool.length].text;
}
